export const EMPLACEMENT = {
  title: 'Liste des emplacements',
  emplacement: 'Emplacement',
  tab: {
    emplacement: 'Emplacements',
    face: 'Faces',
    materiel: 'Matériels',
    dispositif: 'Dispositifs',
  },
  actions: {
    filtre: 'Filtre',
    saveWithoutUpdateDispositifAndMateriel: 'Sauvegarder sans modifier le(s) dispositif(s) et le(s) produit(s)',
    saveWithUpdateDispositifAndMateriel: 'Sauvegarder en modifiant le(s) dispositif(s) et le(s) produit(s)',
  },
  newEmplacement: 'Créer un emplacement',
  typeEmplacement: 'Type d\'emplacement',
  typeEmplacementCreation: 'Type d\'emplacement à créer',
  adresse: 'Adresse',
  parking: 'Parking',
  ligneBus: 'Ligne de bus',
  centreCommercial: 'Centre commercial',
  client: 'Client',
  code: 'Code',
  codeConsultation: 'Code :',
  agence: 'Agence',
  agenceConsultation: 'Agence :',
  libelleConsultation: 'Libellé :',
  descriptionConsultation: 'Description : ',
  type: 'Type',
  libelle: 'Libellé',
  exportTab: 'Exporter',
  codeInseeConsultation: 'Code INSEE : ',
  adresseConsultation: 'Adresse :',
  agglomerationConsultation: 'Agglomération :',
  latConsultation: 'Latitude :',
  longConsultation: 'Longitude :',
  deptConsultation: 'Département :',
  archive: 'Archivé',
  domaine: 'Domaine',
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    code: 'Code(s)',
    codesEmplacement: 'Code(s) emplacement',
    codesDispo: 'Code(s) dispositif',
    codesMateriel: 'Code(s) materiel',
    codesFace: 'Code(s) face',
    ville: 'Ville(s)',
    adresse: 'Adresse',
    agglomerations: 'Agglomération(s)',
    avecCoordonnees: 'Avec coordonées',
    departements: 'Département(s)',
    villeEmplacement: 'Ville(s) emplacement',
    adresseEmplacement: 'Adresse emplacement',
    agglomerationsEmplacement: 'Agglomération(s) emplacement',
    villeDispositif: 'Ville(s) dispositif',
    adresseDispositif: 'Adresse dispositif',
    agglomerationsDispositif: 'Agglomération(s) dispositif',
    agence: 'Agence(s)',
    actif: 'Actif',
    format: 'Format(s)',
    eclaire: 'Eclairé',
    codePostal: 'Code(s) postal',
    domaine: 'Domaine',
    typeMateriel: 'Type(s) de matériel',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    client: 'Client(s)',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver cet emplacement ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver cet emplacement ?',
  },
  popUpChangementInDispositifProduit: {
    title: 'Voulez-vous appliquer le changement d\'adresse sur le dispositif et le(s) produit(s) ?',
  },
  libelleForLogo: 'Emplacement {code}',
  messages: {
    success: {
      archivage: 'Emplacement archivé avec succès.',
      desarchivage: 'Emplacement désarchivé avec succès.',
      suppression: 'Emplacement supprimé avec succès.',
    },
    error: {
      emplacementDispositif: 'L\'emplacement ne peut-être archivé que si ses dispositifs sont à l\'état "démonté"',
      emplacementMateriel: 'L\'emplacement ne peut-être archivé que si ses matériels sont à l\'état "démonté"',
      emplacementFace: 'L\'emplacement ne peut-être archivé que si ses faces sont à l\'état "démonté"',
      emplacementInNLogisticRequest: 'Emplacement {code} est utilisé dans {qte} demande d\'intervention(s)',
      emplacementInNOtTech: 'Emplacement {code} est utilisé dans {qte} OT(s)',
    },
  },
  infoArchivageDesarchivage: {
    archivage: 'Cela va archiver aussi les dispositifs, matériels et faces liés à cet emplacement',
    desarchivage: 'Cela va désarchiver aussi les dispositifs, matériels et faces liés à cet emplacement',
  },
  supprimer: {
    titre: 'Etes-vous sûr de vouloir supprimer cet emplacement ?',
    sousTitre: 'Cela va supprimer aussi les dispositifs liés à cet emplacement',
  },
};

export const ADRESSE_EMPLACEMENT = {
  title: 'Créer une adresse',
  titleModification: 'Modifier adresse {code}',
  code: 'Code',
  caracteristique: 'Caractéristiques',
  libelle: 'Libellé',
  description: 'Description',
  domaine: 'Domaine',
  domaineConsultation: 'Domaine :',
  lineaireFacade: 'Linéaire de façade en mètres',
  lineaireFacadeConsultation: 'Linéaire de façade en mètres :',
  numeroParcelle: 'Numéro de parcelle cadastrale',
  numeroParcelleConsultation: 'Numéro de parcelle cadastrale :',
  natureSolConsultation: 'Nature de sol :',
  public: 'Public',
  prive: 'Privé',
  findAdresseCadastral: 'Rechercher l’adresse cadastrale',
  adresseCadastral: 'Adresse {code}',
  codePostal: 'Code Postal',
  ville: 'Ville',
  pays: 'Pays',
  codeInsee: 'Code INSEE',
  lat: 'Latitude',
  long: 'Longitude',
  agglomeration: 'Agglomération',
  departement: 'Département',
  adresse: 'Adresse cadastrale',
  pj: 'Pièces jointes',
  success: 'Création de l\'emplacement réalisé avec succès.',
  save: 'Modification de l\'emplacement réalisé avec succès.',
  infoGeneral: 'Informations générales',
  infoTechnique: 'Informations techniques',
  otTechnique: 'OT technique',
  codeBarre: 'Code barre',
  degreDeniveleTerrain: 'Degré de dénivelé du terrain',
  accesSiteSurRdv: 'Accès au site sur RDV',
  acces: 'Accès',
  natureSol: 'Nature de sol',
  info: 'Informations',
  archive: 'Archivé',
  groupeDhabitation: 'Groupe d\'habitation',
  numUg: 'N° UG',
  quartier: 'Quartier',
  divers: 'Divers',
};

export const PARKING_EMPLACEMENT = {
  title: 'Créer un parking',
  titleModification: 'Modifier parking  {code}',
  titleConsultation: 'Parking {code}',
  code: 'Code',
  libelle: 'Libellé',
  description: 'Description',
  places: 'Nombre de places',
  niveau: 'Nombre de niveaux',
  placesConsultation: 'Nombre de places :',
  niveauConsultation: 'Nombre de niveaux :',
  lineaireFacade: 'Linéaire de façade en mètres',
  numeroParcelle: 'Numéro de parcelle cadastrale',
  adresse: 'Adresse',
  pj: 'Pièces jointes',
  success: 'Création de l\'emplacement réalisé avec succès.',
  save: 'Modification de l\'emplacement réalisé avec succès.',
  errorNbPlaces: 'Nb places doit contenir que des nombres',
  errorNbNiveau: 'Nb niveaux doit contenir que des nombres',
  archive: 'Archivé',
};

export const CENTRE_COMMERCIAL_EMPLACEMENT = {
  title: 'Créer un centre commercial',
  titleModification: 'Modifier centre commercial {code}',
  titleConsultation: 'Centre commercial {code}',
  caracteristique: 'Caractéristiques',
  audience: 'Audience',
  otTechnique: 'OT technique',
  enseigneMarque: 'Enseignes / Marques',
  code: 'Code',
  libelle: 'Libellé',
  description: 'Description',
  places: 'Nombre de places',
  niveau: 'Nombre de niveaux',
  lineaireFacade: 'Linéaire de façade en mètres',
  numeroParcelle: 'Numéro de parcelle cadastrale',
  adresse: 'Adresse',
  pj: 'Pièces jointes',
  success: 'Création de l\'emplacement réalisé avec succès.',
  save: 'Modification de l\'emplacement réalisé avec succès.',
  habitantAirUrbaine: 'Nb habitants de l\'aire urbaine',
  audianceAn: 'Audience / an',
  nbRepetition: 'Nb de répétition',
  pourcentCouverture: '% de couverture',
  grp: 'GRP',
  audianceHebdo: 'Audience / hebdo',
  nbContactAn: 'Nb contact / an',
  nbContactHebdo: 'Nb contact / hebdo',
  errorHabitantAirUrbaine: 'Nb habitants de l\'aire urbaine doit contenir que des nombres',
  errorAudianceAn: 'Audience / an doit contenir que des nombres',
  errorNbContactsAn: 'Nb contact / an doit contenir que des nombres',
  errorAudianceHebdo: 'Audience / an doit contenir que des nombres',
  errorNbContactsHebdo: 'Nb contact / hebdo doit contenir que des nombres',
  enseigne: 'Enseignes, Marques',
  enseignePrincipale: 'Enseigne principale :',
  creation: 'Créer une enseigne / marque',
  placeholder: 'Rechercher par enseigne ou marque',
  aucuneEnseigne: 'Aucune enseigne sélectionnée',
  localite: 'Localité',
  surface: 'Surface HM',
  revenuNetMenageAn: 'Revenus Net/ an/ Ménage',
  indiceCsp: 'Indice CSP+',
  infoGeneral: 'Informations générales',
  infoTechnique: 'Informations techniques',
  archive: 'Archivé',
};

export const LIGNE_BUS_EMPLACEMENT = {
  title: 'Créer une ligne de bus',
  titleModification: 'Modifier ligne de bus {code}',
  titleConsultation: 'Ligne de bus {code}',
  caracteristique: 'Caractéristiques',
  audience: 'Audience',
  enseigneMarque: 'Enseignes / Marques',
  code: 'Code',
  libelle: 'Libellé',
  description: 'Description',
  adresse: 'Adresse',
  pj: 'Pièces jointes',
  success: 'Création de l\'emplacement réalisé avec succès.',
  save: 'Modification de l\'emplacement réalisé avec succès.',
  depart: 'Point de départ',
  arrive: 'Point d\'arrivée',
  nbBus: 'Nombre de bus circulant',
  departConsultation: 'Point de départ :',
  arriveConsultation: 'Point d\'arrivée :',
  nbBusConsultation: 'Nombre de bus circulant :',
  errorNbBus: 'Nombre de bus circulant doit contenir que des nombres',
  infoGeneral: 'Informations générales',
  infoTechnique: 'Informations techniques',
  archive: 'Archivé',
};

export const DETAIL_EMPLACEMENT = {
  title: 'Détail de l\'emplacement n°',
  titleWithoutN: 'Détail de l\'emplacement',
  emplacement: 'Emplacements',
  dispoPublicitaire: 'Dispositifs publicitaires',
  faces: 'Faces / Spots',
  ajoutDispositif: 'Ajouter un dispositif',
  n: 'N° ',
  faceN: 'Face n°',
  addMateriel: 'Ajouter un matériel',
  numberSpot: 'x{value}',
  timeSpot: 'Spot de {value}s',
  timeLoop: 'Boucle {value}s',
  spots: 'Spots',
  info: 'Informations',
  accesSiteSurRdv: 'Accès au site sur RDV : ',
  acces: 'Accès :',
  natureSol: 'Nature de sol :',
  codeBarre: 'Code barre :',
  degreDeniveleTerrain: 'Degré de dénivelé du terrain :',
  infoGeneral: 'Informations générales',
  infoTechnique: 'Informations techniques',
  archive: 'Archivé',
  monte: 'Monté',
  demonte: 'Démonté',
  encoursDeFabrication: 'En cours de fabrication',
  fabrique: 'Fabriqué',
  aMonterADemonter: 'A monter / à démonter',
  enCoursMontageDemontage: 'En cours montage / démontage',
  groupeDhabitation: 'Groupe d\'habitation :',
  numUg: 'N° UG :',
  quartier: 'Quartier :',
  legende: 'Légende',
  actions: {
    remplacer: 'Remplacer le produit',
    otTech: 'Créer un OT technique',
    displayInactif: 'Afficher les éléments archivés',
    displayActif: 'Masquer les éléments archivés',

  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver cet emplacement ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver cet emplacement ?',
  },
  infoArchivageDesarchivage: {
    archivage: 'Cela va archiver aussi les dispositifs, matériels et faces liés à cet emplacement ?',
    desarchivage: 'Cela va désarchiver aussi les dispositifs, matériels et faces liés à cet emplacement ?',
  },
  messages: {
    success: {
      archivage: 'Emplacement archivé avec succès.',
      desarchivage: 'Emplacement désarchivé avec succès.',
    },
  },
  error: {
    deleteImpossible: 'Suppression impossible',
    remlacementImpossible: 'Remplacement impossible',
  },
  types: {
    client: 'Client',
    adresse: 'Adresse',
    centreCommercial: 'Centre commercial',
    ligneBus: 'Ligne bus',
    parking: 'Parking',
  },
  voirBaux: 'Baux',
  titleAccesRapide: 'Accès rapide',
  steps: {
    caracteristiques: 'Caractéristiques',
    adresse: 'Adresse cadastrale',
    pj: 'Pièces jointes',
  },
  popupDeplacerDispositif: {
    title: 'Déplacement de dispositif',
    deplacer: 'Déplacer',
    dispositif: 'Dispositif',
    code: 'Code dispositif',
    adresse: 'Adresse',
    deplacerVers: 'A déplacer vers l\'emplacement',
    emplacementCode: 'Code emplacement',
    emplacementLibelle: 'Libellé emplacement',
    emplacementDescription: 'Description emplacement',
    placeholder: 'Rechercher un emplacement',
    emplacement: 'Emplacement de destination',
    success: 'Le dispositif a été déplacé avec succès.',
    errors: {
      dispositifId: 'Le dispositif à déplacer.',
      emplacementId: 'L\'emplacement vers qui déplacer.',
      dispositifCanNotBeMoved: 'Le dispositif ne peut être déplacé car il est sur un emplacement client.',
      dispositifCanNotBeMovedToThisLocation: 'Le dispositif ne peut être déplacé vers cet emplacement.',
    },
    titlePopUpPrevenvention: 'Etes-vous sûr de vouloir déplacer ce dispositif ?',
  },
};

export const EMPLACEMENT_DISPO_MATERIEL_FACE_PICKER = {
  tab: {
    emplacement: 'Emplacement: ',
    dispositif: 'Dispositif: ',
    materiel: 'Matériel: ',
    face: 'Face: ',
    numerique: 'Numérique',
    nonNumerique: 'Non numérique',
    type: 'Type: ',
    support: 'Support: ',
    confrere: 'Confrère: ',
    commercialisable: 'Commercialisable',
    nonCommercialisable: 'Non commercialisable',
  },
  ligneFaces: {
    noAffectation: 'Pas d\'affectation',
  },
  archive: 'Archivé',
  error: {
    noResult: 'Aucun emplacement trouvé',
  },
};

export const CLIENT_EMPLACEMENT = {
  title: 'Créer un client',
  titleModification: 'Modifier client {code}',
  code: 'Code',
  caracteristique: 'Caractéristiques',
  libelle: 'Libellé',
  description: 'Description',
  natureSolConsultation: 'Nature de sol :',
  client: 'Client',
  clientConsultation: 'Client :',
  findAdresseCadastral: 'Rechercher l’adresse cadastrale',
  titleConsultation: 'Client {code}',
  codePostal: 'Code Postal',
  ville: 'Ville',
  pays: 'Pays',
  codeInsee: 'Code INSEE',
  lat: 'Latitude',
  long: 'Longitude',
  agglomeration: 'Agglomération',
  departement: 'Département',
  adresse: 'Adresse cadastrale',
  pj: 'Pièces jointes',
  success: 'Création de l\'emplacement réalisé avec succès.',
  save: 'Modification de l\'emplacement réalisé avec succès.',
  infoGeneral: 'Informations générales',
  infoTechnique: 'Informations techniques',
  otTechnique: 'OT technique',
  codeBarre: 'Code barre',
  degreDeniveleTerrain: 'Degré de dénivelé du terrain',
  accesSiteSurRdv: 'Accès au site sur RDV',
  acces: 'Accès',
  natureSol: 'Nature de sol',
  info: 'Informations',
  archive: 'Archivé',
  groupeDhabitation: 'Groupe d\'habitation',
  numUg: 'N° UG',
  quartier: 'Quartier',
  divers: 'Divers',
};
